import React, { useEffect, useRef, useState } from 'react';
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import { AuthProvider } from './context/authcontext';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from './const/const';
import './index.css';
import './style/elementos.css';
import './style/calendario.css';
import './style/slider.css';
import './style/loading.css';
import './style/responsive.css';
import './style/area-staff.css';
import Header from "./components/elementos-wp/header";
import Footer from './components/elementos-wp/footer';
import Form from "./pages/form";
import RegistodoPedido from "./pages/registodopedido";
import Home from "./pages/home";
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import Pagamentos from './components/componente-pagamentos/pagamentos';
import ErroPagina from "./pages/erro404";
import Terms from './pages/terms';
import { useMediaQuery } from 'react-responsive'
import FAQsPage from './pages/faqs';
import FormMarcacaoRapida from './pages/formmarcacaorapida';
import AuditoriaUploads from './pages/auditoria-uploads';


// Auto-logout on expired/missing session (only for list/dashboard routes, not actions)
axios.interceptors.response.use(
  response => response,
  error => {
    const url = error.config?.url || '';
    const isListRoute = url.includes('/api/get_reservas') || url.includes('/auth/me');
    if (error.response?.status === 401 && localStorage.getItem('user') && isListRoute) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

//Chamada à API GraphQL
const client = new ApolloClient({
  uri: '/graphql',
  cache: new InMemoryCache(),
});


// 00fa8d6b-1a47-4f13-8a8d-3adcd9c4a42d - NOME QUE ESCOLHI

// o uso do cache é uma prática recomendada ao utilizar o Apollo Client, 
// melhora o desempenho e reduz a carga no servidor GraphQL, permitindo que dados frequentemente acessados sejam recuperados localmente a partir do cache.


const App = () => {
  // Maintenance mode flag - set to true to show maintenance page
  const [maintenanceMode, setMaintenanceMode] = useState(false);

  // Maintenance Page Component
  const MaintenancePage = () => (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      padding: '20px',
      backgroundColor: '#f8f9fa'
    }}>
      <img 
        src={require("./assets/imagens/logo-main.png")} 
        alt="Indoor Parking" 
        style={{ 
          width: '280px',
          height: 'auto',
          marginBottom: '50px'
        }} 
      />
      <h1 style={{ 
        fontSize: '2rem',
        marginBottom: '10px',
        color: '#333'
      }}>
        Site em Manutenção
      </h1>
      <p style={{ 
        fontSize: '1.2rem',
        maxWidth: '600px',
        lineHeight: '1.6',
        color: '#666'
      }}>
        Estamos a realizar melhorias no nosso sistema para lhe oferecer um serviço ainda melhor.
        Voltaremos em breve!
      </p>
    </div>
  );

  //Responsive
  const isTabletMobile = useMediaQuery({
    query: '(max-width: 1024px)'
  })

  const [domainOrigin, setDomainOrigin] = useState(window.location.origin);

  const [cliquenoParqueHome, setCliquenoParqueHome] = useState(false); // validar o clique na homepage no parque exterior fica com o parque exterior selecionado
  const [isAuthenticated, setIsAuthenticated] = useState(false); //Saber se está logado ou não
  // const [userName, setUserName] = useState(""); //Guarda o nome do user
  const [userData, setUserData] = useState(null);
  const [manterDadosPessoais, setManterDadosPessoais] = useState(false); //Check para passar os dados pessoais para os dados de Pagamento
  const [listadeProdutos, setListadeProdutos] = useState(
    cliquenoParqueHome ?
      [{
        product_id: 195,
        quantity: 1
      }] : [{
        product_id: 213,
        quantity: 1
      }]
  );//Para colocar a reserva a iniciar com o Parque Interior por defeito

  const [idDaOrderSave, SetIdDaOrderSave] = useState(''); //Guardar o id do checkout da reserva
  const [idDoPostSave, SetIdDoPostSave] = useState(''); //Guardar o id da reserva 



  useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setIsAuthenticated(foundUser);
    }
  }, []);



  const aboutUsRef = useRef(null);
  const servicesRef = useRef(null);
  const howItWorksRef = useRef(null);
  const faqsRef = useRef(null);
  const testimonialsRef = useRef(null);

  //GET AOS PRECOS ATUALIZADOS
  useEffect(() => {
    // Function to check maintenance status
    const checkMaintenanceStatus = () => {
      axios.get(`${API_BASE_URL}/api/maintenance?timestamp=${new Date().getTime()}`)
        .then(response => {
          setMaintenanceMode(response.data)
        })
        .catch(error => {
          console.error('Erro:', error);
        });
    };
    
    // Check immediately on component mount
    checkMaintenanceStatus();
    
    // Set up interval to check every minute (60000 ms)
    const intervalId = setInterval(checkMaintenanceStatus, 60000);
    
    // Clean up the interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);


  return (
    <ApolloProvider client={client}>
      <AuthProvider>
        <Router>
          {maintenanceMode ? (
            <MaintenancePage />
          ) : (
            <div>
              <Header
                setCliquenoParqueHome={setCliquenoParqueHome}
                domainOrigin={domainOrigin}
                isAuthenticated={isAuthenticated}
                userData={userData}
                isTabletMobile={isTabletMobile}
                aboutUsRef={aboutUsRef}
                servicesRef={servicesRef}
                howItWorksRef={howItWorksRef}
                faqsRef={faqsRef}
                testimonialsRef={testimonialsRef}
              />
              <Routes>
                <Route exact path="/" element={
                  <Home
                    isTabletMobile={isTabletMobile}
                    setCliquenoParqueHome={setCliquenoParqueHome}
                    aboutUsRef={aboutUsRef}
                    servicesRef={servicesRef}
                    howItWorksRef={howItWorksRef}
                    faqsRef={faqsRef}
                    testimonialsRef={testimonialsRef}
                  />} />
                <Route exact path="/formulario" element={<Form isTabletMobile={isTabletMobile} cliquenoParqueHome={cliquenoParqueHome} domainOrigin={domainOrigin} SetIdDoPostSave={SetIdDoPostSave} idDoPostSave={idDoPostSave} SetIdDaOrderSave={SetIdDaOrderSave} idDaOrderSave={idDaOrderSave} manterDadosPessoais={manterDadosPessoais} setManterDadosPessoais={setManterDadosPessoais} listadeProdutos={listadeProdutos} setListadeProdutos={setListadeProdutos} />} />
                <Route exact path="/formulario/:id" element={<Form isTabletMobile={isTabletMobile} cliquenoParqueHome={cliquenoParqueHome} SetIdDoPostSave={SetIdDoPostSave} SetIdDaOrderSave={SetIdDaOrderSave} domainOrigin={domainOrigin} manterDadosPessoais={manterDadosPessoais} setManterDadosPessoais={setManterDadosPessoais} listadeProdutos={listadeProdutos} setListadeProdutos={setListadeProdutos} />} />
                <Route exact path="/dados-pagamento/reserva/:id" element={<Pagamentos idDoPostSave={idDoPostSave} idDaOrderSave={idDaOrderSave} listadeProdutos={listadeProdutos} manterDadosPessoais={manterDadosPessoais} setManterDadosPessoais={setManterDadosPessoais} />} />
                <Route exact path="/reserva/:id" element={<RegistodoPedido isTabletMobile={isTabletMobile} />} />
                <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/dashboard" element={<Dashboard isTabletMobile={isTabletMobile} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/registar" element={<Register />} />
                <Route path="/auditoria-uploads" element={isAuthenticated ? <AuditoriaUploads /> : <Login setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/faqs" element={<FAQsPage />} />
                <Route path="*" element={<ErroPagina />} />
                <Route path="/termos-e-condicoes" element={<Terms />} />
                <Route path="/marcacao-rapida" element={isAuthenticated ? <FormMarcacaoRapida isTabletMobile={isTabletMobile} cliquenoParqueHome={cliquenoParqueHome} domainOrigin={domainOrigin} SetIdDoPostSave={SetIdDoPostSave} idDoPostSave={idDoPostSave} SetIdDaOrderSave={SetIdDaOrderSave} idDaOrderSave={idDaOrderSave} manterDadosPessoais={manterDadosPessoais} setManterDadosPessoais={setManterDadosPessoais} listadeProdutos={listadeProdutos} setListadeProdutos={setListadeProdutos}  /> : <Login setIsAuthenticated={setIsAuthenticated} />} />
              </Routes>
              <Footer />
            </div>
          )}
        </Router>
      </AuthProvider>
    </ApolloProvider>
  );
};

export default App;


